// extracted by mini-css-extract-plugin
export var pillTrigger = "_5h-0";